<template>
    <div class="checkbox-component">
        <b-checkbox
            true-value="Yes"
            false-value="No"
            v-bind:value="value"
            v-on:input="$emit('input', $event)">
        </b-checkbox>
    </div>
</template>

<script>

export default {
    name: 'Checkbox',
    components: {
    },
    props: {
        component: Object,
        value: String,
        required: Boolean,
    },
    data: function () {
        return {
        }
    },
    methods: {

    },
    mounted(){

    },     
    computed: {

    }
}

</script>

<style>

</style>

